const convertAdPodInfo = (ad) => {
    return {
        totalAds: ad.getTotalAds(),
        adPosition: ad.getAdPosition(),
        isBumper: ad.getIsBumper(),
        podIndex: ad.getPodIndex(),
        timeOffset: ad.getTimeOffset(),
        maxDuration: ad.getMaxDuration(),
    };
};
const convertUniversalAdId = (id) => {
    return {
        adIdRegistry: id.getAdIdRegistry(),
        adIdValue: id.getAdIdValue(),
    };
};
export const convertAdInfo = (e) => {
    const info = e.getAd();
    if (!info) {
        return null;
    }
    return {
        adId: info.getAdId(),
        adTitle: info.getTitle(),
        adDescription: info.getDescription(),
        adSystem: info.getAdSystem(),
        contentType: info.getContentType(),
        duration: info.getDuration(),
        width: info.getWidth(),
        height: info.getHeight(),
        vastMediaWidth: info.getVastMediaWidth(),
        vastMediaHeight: info.getVastMediaHeight(),
        vastMediaBitrate: info.getVastMediaBitrate(),
        linear: info.isLinear(),
        skippable: info.getSkipTimeOffset() > 0,
        skipTimeOffset: info.getSkipTimeOffset(),
        adPodInfo: convertAdPodInfo(info.getAdPodInfo()),
        creativeAdId: info.getCreativeAdId(),
        universalAdIds: info.getUniversalAdIds().map(convertUniversalAdId),
        traffickingParameters: info.getTraffickingParametersString(),
    };
};
